module.exports = __webpack_public_path__ + "img/login.ada2cf21.jpg";